import { t } from 'shared/i18n'
/**
 * パスワードポリシー。
 *
 * 認証状態とは無関係の定数のため、旧 AuthContext 経由ではなく直接 import して使う。
 *
 * NOTE: パスワードのポリシーは Figma が間違っています。
 * 最大文字数は 32 文字ではなく 256 文字です。修正しないようにお願いします。
 */
export const passwordPolicyRegex =
  /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/

// 表示時の言語で返すため関数にする。
export const getPasswordPolicyError = (): string => t('shared.passwordPolicy.passwordPolicyError')
